// ======================================================================
// File Name       : PasswordResetContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';

import {
  GTM_CODE,
  ROOT_URL,
  VALIDATE_TYPE,
} from '../../constants/index';

import { mailPassResetExecution } from '../../actions/AuthAction';
import FormControlValidate from '../../components/FormControlValidate';
import * as MessageTemplate from '../../constants/MessageTemplate';
import * as Path from '../../constants/PathConstants';
import MessageView from '../../components/MessageView';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import { hideLoading, showLoading, setGTMConfig, handleChangePageTitle } from '../../utils/PageUtils';
import Loadable from 'react-loading-overlay';

class PasswordResetContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      enterpriseCd: '',
      serviceCd: '',
      loginId: '',
      mailAddress: '',
    };
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
  }

  componentWillMount() {
    const { location: { pathname } } = this.props;
    if (pathname.indexOf(Path.SUPERUSER_PASSWORD_RESET_REQUEST) > -1) {
      this.setState({
        isEnterprise: true,
      });
    }
    setGTMConfig();

    // Step8.0.3 START
    handleChangePageTitle();
    this.unlisten = this.props.history.listen(() => handleChangePageTitle());
    // Step8.0.3 END
  }

  // Step8.0.3 START  
  componentWillUnmount() {
    this.unlisten();
  }
  // Step8.0.3 END

  /**
   * handle text input change
   */
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  /**
   * Check validate input
   */
  validForm() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  handleResetPassword() {
    const valid = this.validForm();
    if (!valid) {
      return;
    }
    const { enterpriseCd, serviceCd, loginId, mailAddress, isEnterprise } = this.state;
    const { dispatch, location: { search } } = this.props;
    let hashValue = '';
    if (search) {
      const hashValueArr = search.split("=");
      if (hashValueArr.length === 2) {
        hashValue = hashValueArr[1];
      }
    }

    const param = {
      loginId,
      mailAddress,
      loginUrl: `${ROOT_URL}${Path.LOGIN}`,
    };
    if (isEnterprise) {
      param.enterpriseCd = enterpriseCd;
    } else {
      param.serviceCd = serviceCd;
    }

    dispatch(showLoading());
    dispatch(mailPassResetExecution(param)).then((error) => {
      dispatch(hideLoading());
      if (!error) {
        // open complete page
        this.props.history.push(Path.PASSWORD_RESET_REQUEST_COMPLETE);
      }
    })
  }

  handleFormChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  dismissMessage() {
    this.props.dispatch({
      type: HIDE_MESSAGE,
    });
  }

  render() {
    const { enterpriseCd, serviceCd, loginId, mailAddress, isEnterprise } = this.state;
    const { message, showLoading } = this.props;
    this.refsToValidate = [];
    return (
      <Loadable
        active={showLoading}
        spinner
        style={{
          minHeight: '100vh',
        }}
        zIndex={10000}
      >
        <>
          <Col className="container elastic">
            <Col className="margin-top-20 max-width-650">
              {message.messageVisible &&
                !message.targetModal &&
                <MessageView message={message} onDismiss={this.dismissMessage} />}
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.handleResetPassword();
                }}
                className='form-horizontal'>
                <Form.Group>
                  <Col sm={12}>
                    <h1>
                      <strong>パスワードの再設定</strong>
                    </h1>
                  </Col>
                  <Col className="form-label margin-left-20" sm={12}>
                    <p className="margin-top-10">以下のフォームに登録済みのメールアドレスを入力してください。</p>
                    <p className="margin-top-10">パスワード再設定のための案内をお送りします。</p>
                    <p className="margin-top-10">メールアドレスを登録していない場合はパスワード再設定ができないため、</p>
                    <p className="margin-top-10">お客様管理者にお問い合わせください。</p>
                  </Col>
                  <Col className="form-label margin-top-20" sm={12}>
                    <p className="margin-top-10">本人認証のために以下の情報を入力してください。</p>
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={4}>
                    {isEnterprise ? '企業コード' : 'サービスコード'}
                    <span className="required">&nbsp;(※)</span>
                  </Col>
                  <Col sm={8}>
                    {isEnterprise ? (
                      <FormControlValidate
                        label="企業コード"
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        type="text"
                        name="enterpriseCd"
                        maxLength="256"
                        validateType={VALIDATE_TYPE.ID_INCLUDING_HYPHEN}
                        onChange={this.handleFormChange}
                        value={enterpriseCd}
                        required
                      />
                    ) : (
                      <FormControlValidate
                        label="サービスコード"
                        ref={(ref) => {
                          if (ref) {
                            this.refsToValidate.push(ref);
                          }
                        }}
                        type="text"
                        name="serviceCd"
                        maxLength="256"
                        validateType={VALIDATE_TYPE.ID_INCLUDING_HYPHEN}
                        onChange={this.handleFormChange}
                        value={serviceCd}
                        required
                      />
                    )}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={4}>
                    ログインID
                    <span className="required">&nbsp;(※)</span>
                  </Col>
                  <Col sm={8}>
                    <FormControlValidate
                      type="text"
                      label="ログインID"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      name="loginId"
                      onChange={this.handleFormChange}
                      value={loginId}
                      maxLength="256"
                      validateType={isEnterprise ? VALIDATE_TYPE.LOGIN_ID_SU : VALIDATE_TYPE.EMAIL} // Step 11.0.0
                      messageError={MessageTemplate.MSG_ID_INVALID}
                      messageSuccess={MessageTemplate.MSG_ID_VALID}
                      required
                    />
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={4}>
                    メールアドレス
                    <span className="required">&nbsp;(※)</span>
                  </Col>
                  <Col sm={8}>
                    <FormControlValidate
                      type="text"
                      label="メールアドレス"
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                      name="mailAddress"
                      value={mailAddress || ''}
                      onChange={this.handleFormChange}
                      validateType={VALIDATE_TYPE.EMAIL}
                      messageError={MessageTemplate.MSG_EMAIL_INVALID}
                      messageSuccess={MessageTemplate.MSG_EMAIL_VALID}
                      required
                    />
                  </Col>
                </Form.Group>
                <Col sm={12} className="text-center margin-top-20 padding-left-right-clear">
                  <Button type="submit" className="btn-96">
                    送信
                  </Button>
                </Col>
                <input type="submit" hidden />
              </Form>
            </Col>
          </Col>
        </>
      </Loadable>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { logined, authedUser } = state.authed;
  const { message } = state;
  const { showLoading } = state.page;
  return {
    authedUser,
    logined,
    superUser: state.superUser,
    message,
    showLoading,
  };
};
export default connect(mapStateToProps)(PasswordResetContainer);
